import { ClickEvent } from "@mcleod/components";
import { Navigation, RegisteredRoutes } from "@mcleod/core";
import { PortalCompanySettings } from "@mcleod/portal-common";
import { AutogenLayoutDriverApplicationCongrats } from "./autogen/AutogenLayoutDriverApplicationCongrats";

export class DriverApplicationCongrats extends AutogenLayoutDriverApplicationCongrats {

    override onLoad() {
        const settings = PortalCompanySettings.get();
        if (settings != null) {
            this.labelAppReceived.text = settings.dr_response;
            this.labelContact.text = settings.dr_contact_name;
            this.labelContactPhone.text = settings.dr_contact_phone;
            this.labelContactEmail.text = settings.dr_contact_email;
        }

    }

    /** This is an event handler for the onClick event of buttonBackToSignIn.  */
    buttonBackToSignInOnClick(event: ClickEvent) {
        Navigation.navigateTo(RegisteredRoutes.loginRoute);
    }
}
